import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { PAGES_CONFIG } from './../../configs/pages.config'
import { EVENTS_CONFIG } from './../../configs/events.config';
import { ApiBaseService } from './api-base.service';
import { StateService } from './../state.service';
import { AlertService } from './../alert.service';
import { ToastService } from './../toast.service';
import { App, Events, Platform, LoadingController, ToastController } from "ionic-angular";
import { ApiAuthStore } from '../store/api.auth.store';
import { UtilService } from '../util.service';

@Injectable()
export class ApiAuthService extends ApiBaseService {

  protected headers: Headers;

  constructor(
    protected app: App,
    protected events: Events,
    protected http: Http,
    public plt: Platform,
    protected stateService: StateService,
    protected alertService: AlertService,
    protected toastService: ToastService,
    protected loadingCtrl: LoadingController,
    protected toastController: ToastController,
    protected apiAuthStore: ApiAuthStore,
    public utilService: UtilService,
  ) {
    super(app, events, http, plt, stateService, alertService, toastService, loadingCtrl, toastController, apiAuthStore, utilService);
  }

  /**
   * 認証確認
   * @param params 
   * @return void
   */
  post(params: any): void {
    this.doPost({
      url: this.apiAuthStore.url + '/api/v1/auth/check',
      body: {'token': params['token']},
      headers: this.headers
    }).subscribe(
      response => {
        this.events.publish(EVENTS_CONFIG.LOGIN, response);
      },
      error => {
        this.events.publish(EVENTS_CONFIG.SET_ROOT, PAGES_CONFIG.LOGIN);
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/providers/api-call-providers/api-auth.service.ts